<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>Sample</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <h5><strong>Numeric</strong></h5>
                  <p>Use to indicate the numeric values.</p>
                  <b-img
                    src="@/assets/images/pages/pillbadge-sample-1.png"
                    fluid
                    class="pb-3"
                  />
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BImg,
  },
}
</script>
